import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=611e2e17&scoped=true&"
import script from "./tabla.vue?vue&type=script&lang=ts&"
export * from "./tabla.vue?vue&type=script&lang=ts&"
import style0 from "./tabla.vue?vue&type=style&index=0&id=611e2e17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e2e17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
